import { get } from 'svelte/store';
import { DEBUG_CONFIG } from '../mapConstants.js';

// Debug category type
export type DebugCategory = 'containerDetection' | 'shapeMatching' | 'floorChanges' | 'svgUpdates' | 'serviceLocations';

/**
 * Log a debug message if the corresponding category is enabled
 */
export function debugLog(message: string, category: DebugCategory): void {
  const config = get(DEBUG_CONFIG);
  
  const shouldLog = 
    (category === 'containerDetection' && config.logContainerDetection) ||
    (category === 'shapeMatching' && config.logShapeMatching) ||
    (category === 'floorChanges' && config.logFloorChanges) ||
    (category === 'svgUpdates' && config.logSvgUpdates) ||
    (category === 'serviceLocations' && config.logServiceLocations);
  
  if (shouldLog) {
    console.log(`[${category.toUpperCase()}] ${message}`);
  }
}

/**
 * Log a warning message if debug panel is enabled
 */
export function debugWarn(message: string, error?: any): void {
  const config = get(DEBUG_CONFIG);
  
  // Only show warnings if debug panel is enabled (for UI debugging)
  if (!config.showDebugPanel) {
    return;
  }
  
  if (error) {
    console.warn(`[DEBUG] ${message}`, error);
  } else {
    console.warn(`[DEBUG] ${message}`);
  }
}

// Make debug settings accessible globally for testing
if (typeof window !== 'undefined') {
  (window as any).debugSettings = DEBUG_CONFIG;
} 